import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { UitextService } from 'src/app/services/uitext.service';
import { ResultViewModel } from '../../../models/result-view-model';
import { ActivatedRoute } from '@angular/router';
import { Brand } from 'src/brands/brand';
import { HistoryService } from 'src/app/services/history.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  @Input() result?: ResultViewModel | undefined;

  public header: string = "Header placeholder";
  public text: string = "Text placeholder";

  public timestamp = Date.now();
  public timestamp_number = 0;

  public hasJwtToken: boolean = false;

  readonly combinedLayout = Brand.resultLayout === 'combined';

  constructor(public uitextService: UitextService, private activatedRoute: ActivatedRoute, private historyService: HistoryService) { }

  // Not a router navigation: the URL wouldn't change on a second click, so the history wouldn't open again
  openHistory(): void {
    this.historyService.open();
  }

  ngOnInit(): void {

    this.activatedRoute.url.subscribe(url => {
      if (url.length == 2)
        this.hasJwtToken = true;
    });

    if (this.result?.total?.created_at) {
      this.timestamp = (new Date(this.result?.total?.created_at)).getTime();
      this.setTimestamp();
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName !== "result" || !changes[propName].currentValue)
        return;

      this.result = changes[propName].currentValue;
      this.header = await this.uitextService.getTotalResultHeader(this.result?.total?.risk_id ?? 0);
      this.text = await this.uitextService.getTotalResultText(this.result?.total?.risk_id ?? 0);

      if (this.result?.total?.created_at) {
        this.timestamp = (new Date(this.result?.total?.created_at)).getTime();
        this.setTimestamp();
      }
    }
  }

  public setTimestamp() {
    let date1 = new Date(this.timestamp);
    let date2 = new Date();
    let Difference_In_Time = date2.getTime() - date1.getTime();
    this.timestamp_number = Math.round(Difference_In_Time / (1000 * 3600 * 24));
  }
}
